import React, { Component, useEffect, useState } from "react";
import Form from "../comman/form";
import { Modal, Button } from "react-bootstrap";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import UploadDocument from "../comman/UploadDocument";
import auth, { getCurrentUser } from "../services/authService";
import config from "../config.json";
import WorkflowElement from "../app/components/WorkflowElement";
import { useDispatch, useSelector } from "react-redux";
import {
  getComplianceBprmForm,
  getCurrentComplianceWorkflowTask,
  getStartedComplianceAppData,
  loadComplianceBprmForm,
  loadComplianceCurrentWorkflowTask,
  startComplianceApplication,
} from "../app/store/complianceReports";

const AddComplaince = (props) => {
  const { showHideCompliance, handleShowHideCompliance, type, selectedObj } =
    props;

  const [workflowTask, setWorkflowTask] = useState(null);
  const [btnProcess, setBtnProcess] = useState(false);
  const [reqCount, setReqCount] = useState(0);
  const [apiCallCount, setApiCallCount] = useState(0);
  const [workflowFormData, setWorkflowFormData] = useState(null);
  const [documentInfo, setDocumentInfo] = useState({
    docType: "compliance",
    updType: "compliance",
    message: "Compliance Document",
  });
  const [wfForm, setWfForm] = useState(null);

  const compliacneAppStartedDataSelector = useSelector(
    getStartedComplianceAppData,
  );
  const complianceCurrentWorkflowTaskSelector = useSelector(
    getCurrentComplianceWorkflowTask,
  );
  const complianceBprmFormSelector = useSelector(getComplianceBprmForm);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedObj) {
      const data = {};
      data["compliance.Id"] = selectedObj.id;
      data["compliance.Name"] = selectedObj.name;
      data["compliance.Year"] = selectedObj.year;
      data["compliance.Total_Invoice_Amt"] = selectedObj.totalInvoiceAmount;
      data["compliance.Total_Paid_Amt"] = selectedObj.totalPaidAmount;
      data["compliance.Total_Balance_Amt"] = selectedObj.totalDueAmount;
      if (type === "w2")
        data["compliance.Notes"] =
          "Attached is your previous year's W2 Wage and Tax statement.";
      else
        data["compliance.Notes"] =
          "Attached is your previous year's 1099-NEC statement.";
      setWorkflowFormData(data);
    }
  }, [selectedObj]);

  const handleRunApplication = () => {
    setBtnProcess(true);
    const newApplication = {
      workflowId: config.workflowsIds.compliance.subcontractor,
      performerId: parseInt(currentUser.id),
      applicationId: 1,
    };
    dispatch(startComplianceApplication(newApplication));
  };

  useEffect(() => {
    if (compliacneAppStartedDataSelector?.ciid > 0 && reqCount === 0) {
      setTimeout(() => {
        dispatch(
          loadComplianceCurrentWorkflowTask(compliacneAppStartedDataSelector),
        );
        setReqCount(1);
      }, 3000);
    }
  }, [compliacneAppStartedDataSelector]);

  useEffect(() => {
    if (
      complianceCurrentWorkflowTaskSelector?.formId === null &&
      reqCount <= 3
    ) {
      setTimeout(async () => {
        dispatch(
          loadComplianceCurrentWorkflowTask(compliacneAppStartedDataSelector),
        );
        const rqCount = reqCount + 1;
        setReqCount(rqCount);
      }, 3000);
    } else if (complianceCurrentWorkflowTaskSelector?.wiid > 0) {
      setWorkflowTask(complianceCurrentWorkflowTaskSelector);
      setBtnProcess(false);
      dispatch(
        loadComplianceBprmForm(complianceCurrentWorkflowTaskSelector.formId),
      );
    } else if (reqCount >= 3) {
      handleShowHideCompliance("", "save");
    }
  }, [complianceCurrentWorkflowTaskSelector]);

  const handleNextTask = () => {
    setTimeout(() => {
      dispatch(loadComplianceCurrentWorkflowTask(workflowTask));
      setReqCount(1);
    }, 3000);
  };

  useEffect(() => {
    setWfForm(complianceBprmFormSelector);
  }, [complianceBprmFormSelector]);

  let notes = "";
  if (type === "w2")
    notes = "Attached is your previous year's W2 Wage and Tax statement.";
  else notes = "Attached is your previous year's 1099-NEC statement.";

  const modalTitle = type === "w2" ? "Upload W2 Statement" : "Upload 1099-NEC";
  const modalIcon = type === "w2" ? "fa-file-text-o" : "fa-file-o";
  const badgeLabel = type === "w2" ? "W2" : "1099-NEC";
  const modalDescription = type === "w2"
    ? "Upload and process W2 Wage and Tax statements for compliance records."
    : "Upload and process 1099-NEC statements for subcontractor compliance.";

  const handleClose = () => handleShowHideCompliance("", "");

  return (
    <React.Fragment>
      <Modal
        show={showHideCompliance}
        onHide={handleClose}
        size="lg"
        dialogClassName="ac-compliance-modal"
        centered
      >
        <style>{`
          /* Ensure the modal and backdrop are on top of other elements */
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }

          /* Glassmorphic backdrop filter and blur */
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }

          /* Spring-like transition for scale-in animation */
          .modal.fade .ac-compliance-modal.modal-dialog {
            transform: scale(0.96) !important;
            transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .ac-compliance-modal.modal-dialog {
            transform: scale(1) !important;
          }

          .ac-compliance-modal {
            font-family: "Open Sans", sans-serif !important;
          }

          .ac-compliance-modal .modal-content {
            border-radius: 0 !important;
            box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
          }
          .ac-compliance-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 14px 24px !important;
            background: #ffffff !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .ac-compliance-modal .modal-header::before {
            display: none !important;
          }
          .ac-compliance-modal .ac-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 10px !important;
            width: 100% !important;
          }
          .ac-compliance-modal .ac-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 16px !important;
            width: 100% !important;
          }
          .ac-compliance-modal .ac-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .ac-compliance-modal .ac-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
          }
          .ac-compliance-modal .ac-header-icon {
            width: 38px !important;
            height: 38px !important;
            min-height: 38px !important;
            border-radius: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: #171717 !important;
            background: #f5f5f5 !important;
            border: 1px solid #d4d4d4 !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
            font-size: 16px !important;
            flex-shrink: 0 !important;
          }
          .ac-compliance-modal .ac-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 17px !important;
            font-weight: 600 !important;
            line-height: 1.25 !important;
            min-width: 0 !important;
          }
          .ac-compliance-modal .ac-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .ac-compliance-modal .ac-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 3px 8px !important;
            border-radius: 0 !important;
            font-size: 10px !important;
            font-weight: 700 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            background: #171717 !important;
            color: #ffffff !important;
            border: 1px solid #171717 !important;
          }
          .ac-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 8px 10px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .ac-meta-desc {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            color: #64748b !important;
            font-weight: 400 !important;
            line-height: 1.4 !important;
          }
          .ac-meta-desc i {
            color: #94a3b8 !important;
          }
          .ac-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 3px 8px !important;
            border-radius: 0 !important;
            font-weight: 600 !important;
            color: #0f172a !important;
            border: 1px solid #cbd5e1 !important;
            font-size: 11.5px !important;
          }
          .ac-meta-chip i {
            color: #64748b !important;
            font-size: 11px !important;
          }
          .ac-meta-divider {
            width: 1px !important;
            height: 14px !important;
            background: #cbd5e1 !important;
            margin: 0 2px !important;
          }

          /* Close Button */
          .ac-compliance-modal .ac-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 32px !important;
            height: 32px !important;
            padding: 0 !important;
            font-size: 14px !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
            outline: none !important;
          }
          .ac-compliance-modal .ac-action-btn:hover {
            color: #ef4444 !important;
            border-color: #fca5a5 !important;
            background: #fef2f2 !important;
            transform: translateY(-1px) !important;
          }

          .ac-compliance-modal .modal-body {
            padding: 20px 24px !important;
            background: #ffffff !important;
            max-height: calc(100vh - 220px) !important;
            overflow-y: auto !important;
          }

          /* Custom scrollbar for modal body */
          .ac-compliance-modal .modal-body::-webkit-scrollbar {
            width: 6px !important;
            height: 6px !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-track {
            background: transparent !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-thumb {
            background: #cbd5e1 !important;
            border-radius: 0 !important;
          }
          .ac-compliance-modal .modal-body::-webkit-scrollbar-thumb:hover {
            background: #94a3b8 !important;
          }

          /* Upload prompt card */
          .ac-compliance-modal .ac-upload-card {
            display: flex !important;
            align-items: center !important;
            gap: 16px !important;
            padding: 16px 20px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            box-shadow: none !important;
          }
          .ac-compliance-modal .ac-upload-card-icon {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #0f172a !important;
            font-size: 16px !important;
            flex-shrink: 0 !important;
          }
          .ac-compliance-modal .ac-upload-card-body {
            display: flex !important;
            flex-direction: column !important;
            gap: 10px !important;
            flex: 1 !important;
          }
          .ac-compliance-modal .ac-upload-card-text {
            font-size: 13.5px !important;
            color: #1e293b !important;
            font-weight: 500 !important;
            line-height: 1.5 !important;
          }
          .ac-compliance-modal .ac-upload-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            align-self: flex-start !important;
            padding: 7px 16px !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            color: #ffffff !important;
            background: #2563eb !important;
            border: 1px solid #2563eb !important;
            border-radius: 0 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
            outline: none !important;
          }
          .ac-compliance-modal .ac-upload-btn:hover {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
          }
          .ac-compliance-modal .ac-upload-btn:active {
            transform: translateY(0) !important;
          }
          .ac-compliance-modal .ac-upload-btn:disabled {
            background: #cbd5e1 !important;
            border-color: #cbd5e1 !important;
            color: #94a3b8 !important;
            opacity: 0.85 !important;
            cursor: not-allowed !important;
            transform: none !important;
            box-shadow: none !important;
          }

          /* General form overrides inside the compliance modal */
          .ac-compliance-modal .modal-body label,
          .ac-compliance-modal .modal-body .control-label {
            font-size: 11.5px !important;
            font-weight: 700 !important;
            color: #334155 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            margin-bottom: 6px !important;
          }
          .ac-compliance-modal .modal-body input[type="text"],
          .ac-compliance-modal .modal-body input[type="email"],
          .ac-compliance-modal .modal-body input[type="date"],
          .ac-compliance-modal .modal-body input[type="time"],
          .ac-compliance-modal .modal-body select,
          .ac-compliance-modal .modal-body textarea,
          .ac-compliance-modal .modal-body .form-control {
            font-size: 13.5px !important;
            color: #0f172a !important;
            background-color: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            padding: 8px 12px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
            transition: all 0.2s ease !important;
            outline: none !important;
          }
          .ac-compliance-modal .modal-body input:focus,
          .ac-compliance-modal .modal-body select:focus,
          .ac-compliance-modal .modal-body textarea:focus,
          .ac-compliance-modal .modal-body .form-control:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
            outline: none !important;
          }

          /* Modernized tables inside compliance modal */
          .ac-compliance-modal .modal-body table.table,
          .ac-compliance-modal .modal-body .table {
            width: 100% !important;
            margin-bottom: 1rem !important;
            color: #1e293b !important;
            border-collapse: separate !important;
            border-spacing: 0 2px !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            background-color: #ffffff !important;
          }
          .ac-compliance-modal .modal-body table.table th,
          .ac-compliance-modal .modal-body .table th {
            background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
            color: #64748b !important;
            font-weight: 600 !important;
            font-size: 12px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.6px !important;
            padding: 12px 14px !important;
            border-bottom: 2px solid #e2e8f0 !important;
            border-top: none !important;
          }
          .ac-compliance-modal .modal-body table.table td,
          .ac-compliance-modal .modal-body .table td {
            padding: 12px 14px !important;
            font-size: 13.5px !important;
            vertical-align: middle !important;
            border-bottom: 1px solid #f1f5f9 !important;
            border-top: none !important;
            background: #ffffff !important;
          }
          .ac-compliance-modal .modal-body table.table tr:last-child td,
          .ac-compliance-modal .modal-body .table tr:last-child td {
            border-bottom: none !important;
          }
          .ac-compliance-modal .modal-body table.table tbody tr:hover td,
          .ac-compliance-modal .modal-body .table tbody tr:hover td {
            background-color: #f8fafc !important;
          }

          /* Internal buttons inside forms */
          .ac-compliance-modal .modal-body .btn,
          .ac-compliance-modal .modal-body button.btn-primary,
          .ac-compliance-modal .modal-body button.btn-default,
          .ac-compliance-modal .modal-body button.btn-success {
            padding: 7px 16px !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            border-radius: 0 !important;
            letter-spacing: normal !important;
            transition: all 0.2s ease !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          }
          .ac-compliance-modal .modal-body .btn-primary {
            background: #2563eb !important;
            border: 1px solid #2563eb !important;
            color: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .btn-primary:hover {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
          }
          .ac-compliance-modal .modal-body .btn-success {
            background: #16a34a !important;
            border: 1px solid #16a34a !important;
            color: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .btn-success:hover {
            background: #15803d !important;
            border-color: #15803d !important;
          }
          .ac-compliance-modal .modal-body .btn-default {
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            color: #1e293b !important;
          }
          .ac-compliance-modal .modal-body .btn-default:hover {
            background: #f8fafc !important;
            border-color: #94a3b8 !important;
          }

          /* Card and section layout */
          .ac-compliance-modal .modal-body .card,
          .ac-compliance-modal .modal-body .panel {
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            overflow: hidden !important;
            margin-bottom: 16px !important;
            background: #ffffff !important;
          }
          .ac-compliance-modal .modal-body .card-header,
          .ac-compliance-modal .modal-body .panel-heading {
            background: #f8fafc !important;
            border-bottom: 1px solid #e2e8f0 !important;
            padding: 10px 16px !important;
            font-weight: 600 !important;
            font-size: 13px !important;
            color: #0f172a !important;
          }
          .ac-compliance-modal .modal-body .card-body,
          .ac-compliance-modal .modal-body .panel-body {
            padding: 16px !important;
          }

          /* Modal Footer */
          .ac-compliance-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 14px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
          }
          .ac-compliance-modal .ac-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            padding: 7px 16px !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
          }
          .ac-compliance-modal .ac-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
          }
`}</style>
        <Modal.Header>
          <div className="ac-header-shell">
            <div className="ac-header-top">
              <div className="ac-header-main">
                <i className={`ac-header-icon fa ${modalIcon}`} aria-hidden="true" />
                <div className="ac-header-copy">
                  <h2 className="ac-modal-title">
                    <span className="ac-modal-title-text">
                      <span>{modalTitle}</span>
                      <span className="ac-modal-title-badge">
                        {badgeLabel}
                      </span>
                    </span>
                  </h2>
                  <div className="ac-modal-meta-row">
                    {selectedObj?.name && (
                      <span className="ac-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {selectedObj.name}
                      </span>
                    )}
                    {selectedObj?.name && modalDescription && (
                      <span className="ac-meta-divider" />
                    )}
                    <span className="ac-meta-desc">
                      <i className="fa fa-info-circle" aria-hidden="true" /> {modalDescription}
                    </span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="ac-action-btn"
                onClick={handleClose}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!wfForm && (
            <div className="ac-upload-card">
              <div className="ac-upload-card-icon">
                <i className="fa fa-cloud-upload" aria-hidden="true" />
              </div>
              <div className="ac-upload-card-body">
                <div className="ac-upload-card-text">{notes}</div>
                <button
                  className="ac-upload-btn"
                  disabled={btnProcess}
                  onClick={() => handleRunApplication()}
                >
                  {btnProcess && <i className="fa fa-spinner fa-spin"></i>}
                  <i className="fa fa-upload" aria-hidden="true"></i>
                  Upload Document
                </button>
              </div>
            </div>
          )}

          {wfForm && (
            <div className="col-md-12">
              <WorkflowElement
                wfTask={workflowTask}
                wfForm={wfForm}
                handleNextTask={handleNextTask}
                workflowFormData={workflowFormData}
                documentInfo={documentInfo}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="ac-footer-close-btn"
            onClick={handleClose}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AddComplaince;
